import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { IntakeSettingsComponent } from 'src/app/components/intake-settings/intake-settings.component';
import { SlackTextEditorComponent } from 'src/app/components/slack-text-editor/slack-text-editor.component';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';

import { AdminSlackRoutingModule } from './admin-slack-routing.module';
import { AdminSlackComponent } from './admin-slack.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminSlackRoutingModule,
    NgxDatatableModule,
    SharedPipesModule,
    IntakeSettingsComponent,
    SlackTextEditorComponent,
  ],
  declarations: [AdminSlackComponent],
})
export class AdminSlackModule {}
